var _style, _g, _path, _path2, _path3, _g2, _path4, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFnaim(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 61.5 51.8",
    style: {
      enableBackground: "new 0 0 61.5 51.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#FFD405;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:url(#SVGID_2_);}\n\t.st4{fill:url(#SVGID_3_);}\n\t.st5{fill:#1E1E1C;}\n\t.st6{fill:url(#SVGID_4_);}\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.4,40.2h0.5l1,2.1H4.5l-0.2-0.5H3l-0.2,0.5H2.4L3.4,40.2z M4.1,41.5l-0.4-0.9l-0.4,0.9H4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.9,41.3v1.1H7.6l-0.1-0.2c-0.2,0.1-0.4,0.2-0.8,0.2c-0.5,0-1.2-0.3-1.2-1.1c0-0.6,0.3-1.1,1.2-1.1 c0.5,0,1,0.2,1.1,0.7H7.4c0-0.1-0.2-0.4-0.7-0.4c-0.7,0-0.8,0.4-0.8,0.7c0,0.5,0.3,0.8,0.8,0.8c0.4,0,0.6-0.1,0.7-0.4H6.7v-0.3 H7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.8,40.2h0.4v2.1H8.8V40.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.2,40.2h1.3c0.5,0,0.9,0.1,0.9,0.6c0,0.4-0.3,0.6-0.6,0.6l0.7,0.9h-0.5l-0.6-0.8h-0.7v0.8h-0.4V40.2z  M11.4,41.2c0.3,0,0.5,0,0.5-0.3c0-0.2-0.2-0.3-0.5-0.3h-0.8v0.6H11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.8,40.2H16c0.4,0,0.9,0,0.9,0.7c0,0.6-0.6,0.6-0.9,0.6h-0.8v0.8h-0.4V40.2z M16.1,41.2 c0.2,0,0.4,0,0.4-0.3c0-0.3-0.2-0.3-0.4-0.3h-0.9v0.6H16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.8,40.2c0.9,0,1.3,0.5,1.3,1.1c0,0.4-0.3,1.1-1.3,1.1c-1,0-1.3-0.7-1.3-1.1 C17.6,40.7,17.9,40.2,18.8,40.2z M19.7,41.3c0-0.5-0.4-0.7-0.8-0.7S18,40.8,18,41.3c0,0.6,0.5,0.8,0.8,0.8 C19.2,42,19.7,41.9,19.7,41.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.2,41.4c0,0.7-0.4,1-1.1,1c-0.7,0-1.1-0.3-1.1-1v-1.2h0.4v1.2c0,0.4,0.1,0.6,0.7,0.6 c0.6,0,0.7-0.3,0.7-0.6v-1.2h0.4V41.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.2,40.2h1.3c0.5,0,0.9,0.1,0.9,0.6c0,0.4-0.3,0.6-0.6,0.6l0.7,0.9h-0.5l-0.6-0.8h-0.7v0.8h-0.4V40.2z  M25.4,41.2c0.3,0,0.5,0,0.5-0.3c0-0.2-0.2-0.3-0.5-0.3h-0.8v0.6H25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.8,40.2h0.4V42h1.5v0.4h-2V40.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.5,40.2h1.9v0.4h-1.5v0.5h1.3v0.4h-1.3V42h1.5v0.4h-1.9V40.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.8,40.2h0.4V42h1.5v0.4h-2V40.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.7,40.2c0.9,0,1.3,0.5,1.3,1.1c0,0.4-0.3,1.1-1.3,1.1c-1,0-1.3-0.7-1.3-1.1 C38.4,40.7,38.7,40.2,39.7,40.2z M40.5,41.3c0-0.5-0.4-0.7-0.8-0.7c-0.5,0-0.8,0.2-0.8,0.7c0,0.6,0.5,0.8,0.8,0.8 C40.1,42,40.5,41.9,40.5,41.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44,41.3v1.1h-0.3l-0.1-0.2c-0.2,0.1-0.4,0.2-0.8,0.2c-0.5,0-1.2-0.3-1.2-1.1c0-0.6,0.3-1.1,1.2-1.1 c0.5,0,1,0.2,1.1,0.7h-0.4c0-0.1-0.2-0.4-0.7-0.4c-0.7,0-0.8,0.4-0.8,0.7c0,0.5,0.3,0.8,0.8,0.8c0.4,0,0.6-0.1,0.7-0.4h-0.7 v-0.3H44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.9,40.2h1.9v0.4h-1.5v0.5h1.3v0.4h-1.3V42h1.5v0.4h-1.9V40.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48,40.7L48,40.7l0,1.6h-0.4v-2.1h0.6l0.7,1.6l0.7-1.6H50v2.1h-0.4v-1.6h0L49,42.4h-0.3L48,40.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51,40.2h1.9v0.4h-1.5v0.5h1.3v0.4h-1.3V42h1.5v0.4H51V40.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.7,40.2h0.4l1.4,1.5v-1.5H56v2.1h-0.4l-1.5-1.6v1.6h-0.4V40.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.7,40.6h-0.9v-0.4h2.3v0.4h-0.9v1.8h-0.4V40.6z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 39.4,
    className: "st1",
    width: 0.5,
    height: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 39.4,
    className: "st1",
    width: 0.5,
    height: 3.8
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.3531,
    y1: 8.0287,
    x2: 7.2549,
    y2: 9.8117
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE90B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFD004"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M36.3,0.4C36.6,0.1,36.9,0,37.2,0L24.5,0l0,0c-0.3,0-0.6,0.1-0.8,0.4L7.3,16.7c0,0-0.1,0.1-0.1,0.1 C7,17.1,7,17.3,7,17.6h12.6c0-0.3,0.1-0.6,0.4-0.9L36.3,0.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.9372,
    y1: 37.5492,
    x2: 35.6974,
    y2: 13.7204
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD004"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEEB17"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M54.4,16.7c0.5,0.5,0.5,1.3,0,1.8L38.1,34.8c-0.2,0.2-0.6,0.4-0.9,0.4c-0.3,0-0.6-0.1-0.9-0.4L20,18.5 c-0.5-0.5-0.5-1.3,0-1.8L36.3,0.4C36.6,0.1,36.9,0,37.2,0c0.3,0,0.6,0.1,0.9,0.4L54.4,16.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -581.7015,
    y1: 1439.8953,
    x2: -525.3275,
    y2: 1439.8953,
    gradientTransform: "matrix(-0.7812 0.6243 -0.6243 -0.7812 506.3631 1471.0846)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4424,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5697
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M37.2,0c-0.3,0-0.6,0.1-0.9,0.4L20,16.7c-0.3,0.3-0.4,0.8-0.3,1.2c2.9-1,5.8-2.6,8.4-4.6 C32.5,9.7,35.6,5.1,37.2,0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M24.3,15.2h4.6V16h-3.6v1.2h3.1v0.8h-3.1v2.2h-1V15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M29.7,15.2h1l3.4,3.6v-3.6H35v5h-0.9l-3.5-3.8v3.8h-0.9V15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M38.1,15.2h1.1l2.4,5h-1l-0.5-1.2h-2.9l-0.5,1.2h-1L38.1,15.2z M39.7,18.2l-1-2.2l-1,2.2H39.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M42.4,15.2h1v5h-1V15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M45.5,16.4L45.5,16.4l0,3.8h-0.9v-5h1.3l1.6,3.7l1.6-3.7h1.3v5h-0.9v-3.8h0l-1.6,3.8h-0.8L45.5,16.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.9402,
    y1: 27.2252,
    x2: 19.6535,
    y2: 40.6365
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3C100"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D5A105"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M20,18.5c-0.2-0.2-0.4-0.6-0.4-0.9v0H7c0,0.3,0.1,0.5,0.2,0.7c0,0,0.1,0.1,0.1,0.1l16.4,16.4 c0.2,0.2,0.5,0.3,0.8,0.4l12.7,0c-0.3,0-0.6-0.1-0.9-0.4L20,18.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20,16.7L36.3,0.4C36.6,0.1,36.9,0,37.2,0l-0.8,0c-0.1,0.1-0.2,0.1-0.3,0.2L19.7,16.6 c-0.2,0.2-0.4,0.6-0.4,0.9H7c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c2,0,11.4,0,12.6,0C19.6,17.4,19.7,17,20,16.7z"
  }))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.9,51.7H0v-4h1.4c1.1,0,1.5,0.6,1.5,1.3c0,0.7-0.4,1.3-1.5,1.3H0.9V51.7z M0.9,49.5h0.5 c0.4,0,0.5-0.3,0.5-0.5s-0.1-0.5-0.5-0.5H0.9V49.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3,51.7l1.1-4.1h1l1.1,4.1H5.3l-0.2-0.8h-1l-0.2,0.8H3z M4.3,50.2H5l-0.3-1.5L4.3,50.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.9,51.7H7v-4h1.4c1.1,0,1.4,0.5,1.4,1.3c0,0.5-0.1,0.9-0.6,1.1l0.7,1.7H9l-0.5-1.5H7.9V51.7z M7.9,49.4h0.6 c0.4,0,0.4-0.3,0.4-0.5c0-0.2,0-0.5-0.4-0.5H7.9V49.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.1,48.4v3.3h-0.9v-3.3h-1v-0.8h2.8v0.8H12.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.3,50h-1.6v0.9h1.7v0.8h-2.6v-4h2.6v0.8h-1.7v0.8h1.6V50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.4,51.7l-1.3-2.4l0,2.4h-0.9v-4h0.9l1.3,2.4l0-2.4h0.9v4H19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21,51.7l1.1-4.1h1l1.1,4.1h-0.9l-0.2-0.8h-1l-0.2,0.8H21z M22.3,50.2H23l-0.3-1.5L22.3,50.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.1,51.7v-4h0.9v4H25.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.8,51.7h-0.9v-4h1.4c1.1,0,1.4,0.5,1.4,1.3c0,0.5-0.1,0.9-0.6,1.1l0.7,1.7h-1l-0.5-1.5h-0.6V51.7z  M27.8,49.4h0.6c0.4,0,0.4-0.3,0.4-0.5c0-0.2,0-0.5-0.4-0.5h-0.6V49.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33,50h-1.6v0.9h1.7v0.8h-2.6v-4h2.6v0.8h-1.7v0.8H33V50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.9,50h-1.6v0.9h1.7v0.8h-2.6v-4h2.6v0.8h-1.7v0.8h1.6V50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.5,50.3l-0.7,1.5h-1l1.1-2.1l-1-1.9h1l0.7,1.4l0.7-1.4h1l-1,1.9l1.1,2.1h-1L40.5,50.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.6,47.6c0.5,0,0.7,0.1,0.8,0.2v0.8c-0.2-0.1-0.4-0.2-0.8-0.2c-0.7,0-1,0.3-1,1.3c0,1,0.3,1.3,1,1.3 c0.3,0,0.5-0.1,0.8-0.2v0.8c-0.2,0.1-0.4,0.2-0.8,0.2c-1.2,0-1.7-0.6-1.7-2.1C42.9,48.2,43.4,47.6,44.6,47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.2,50.9h1.6v0.8h-2.5v-4h0.9V50.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.5,50.4v-2.8h0.9v2.7c0,0.5,0.3,0.6,0.6,0.6c0.3,0,0.6-0.1,0.6-0.6v-2.7h0.9v2.8c0,1.1-0.9,1.4-1.5,1.4 S49.5,51.5,49.5,50.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.2,50.4c0,1-0.6,1.4-1.6,1.4c-0.4,0-1-0.1-1.3-0.2v-0.9c0.2,0.1,0.6,0.3,1.2,0.3c0.6,0,0.8-0.2,0.8-0.5 c0-0.3-0.1-0.4-0.5-0.5c-1-0.1-1.4-0.4-1.4-1.2c0-0.7,0.4-1.2,1.5-1.2c0.6,0,1,0.1,1.1,0.2v0.8c-0.2-0.1-0.7-0.2-1.1-0.2 c-0.4,0-0.7,0.1-0.7,0.4c0,0.3,0.2,0.4,0.6,0.4C55.7,49.4,56.2,49.6,56.2,50.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.1,51.7v-4h0.9v4H57.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.3,50.1h-1.5v1.7h-0.9v-4h2.6v0.8h-1.7v0.8h1.5V50.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFnaim);
export default __webpack_public_path__ + "static/media/fnaim.79526b13cd0c435097e323f917a7b455.svg";
export { ForwardRef as ReactComponent };